'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { Modal } from '@/components/ui/modal';
import { useModal } from './use-modal';

export default function GlobalModal() {
  const { isOpen, view, closeModal, customSize } = useModal();
  const pathname = usePathname();
  useEffect(() => {
    closeModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      customSize={customSize}
      overlayClassName="bg-gray-900/40 dark:bg-black/60"
      containerClassName="max-h-[90vh] overflow-y-auto rounded-xl border border-gray-200 bg-white shadow-popover dark:bg-gray-100"
    >
      {view}
    </Modal>
  );
}
